var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Button from "syf-component-library/ui/atoms/Button";
import styled from "styled-components";
import { fontWeights, spacing } from "syf-component-library/defaultTheme";
import { FontSizes } from "../../../const/baseTheme";
export var MakeAPaymentWrap = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: ", ";\n  height: ", "px;\n  margin: 0;\n  padding: 0 ", "px;\n  width: 100%;\n"], ["\n  font-weight: ", ";\n  height: ", "px;\n  margin: 0;\n  padding: 0 ", "px;\n  width: 100%;\n"])), fontWeights.semiBold, FontSizes.xxxLarge, spacing.xxlarge);
var templateObject_1;
//# sourceMappingURL=MakeAPaymentButton.styles.js.map